(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dixie-employment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('das-emp-form');
    if (!form) return;
    var btn = document.getElementById('das-emp-submit');
    var result = document.getElementById('das-emp-result');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Sending...';
      result.className = 'das-emp__result';
      result.textContent = '';

      var data = new FormData(form);

      fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.success) {
          result.className = 'das-emp__result is-ok';
          result.textContent = form.getAttribute('data-success') || 'Thanks, your application is in.';
          form.reset();
          btn.textContent = original;
        } else {
          result.className = 'das-emp__result is-err';
          result.textContent = 'Something went wrong - please call the yard or try again.';
          btn.disabled = false;
          btn.textContent = original;
        }
      })
      .catch(function () {
        result.className = 'das-emp__result is-err';
        result.textContent = 'Something went wrong - please call the yard or try again.';
        btn.disabled = false;
        btn.textContent = original;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dixie-warranty"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('.mm-acc__head').forEach(function (btn) {
        if (btn.dataset.mmInit === 'true') return;
        btn.dataset.mmInit = 'true';
        btn.addEventListener('click', function () {
          var item = btn.closest('.mm-acc__item');
          var open = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }
    function run() { document.querySelectorAll('.mm-warr-section').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.mm-warr-section'); if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-in-store-specials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('.mm-special-card__media').forEach(function (media) {
        if (media.dataset.mmInit === 'true') return;
        media.dataset.mmInit = 'true';
        var count = parseInt(media.dataset.count, 10) || 0;
        if (count < 2) return;
        var track = media.querySelector('.mm-special-card__track');
        var dots = media.querySelectorAll('.mm-dot');
        function go(idx) {
          idx = (idx + count) % count;
          media.dataset.idx = idx;
          track.style.transform = 'translateX(' + (-idx * 100) + '%)';
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        media.addEventListener('click', function (e) {
          var arrow = e.target.closest('.mm-arrow');
          var dot = e.target.closest('.mm-dot');
          if (arrow) { e.preventDefault(); go(parseInt(media.dataset.idx, 10) + parseInt(arrow.dataset.dir, 10)); }
          if (dot) { e.preventDefault(); go(parseInt(dot.dataset.i, 10)); }
        });
      });
    }
    function run() { document.querySelectorAll('.mm-specials').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.mm-specials'); if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-warranty"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('.mm-acc__head').forEach(function (btn) {
        if (btn.dataset.mmInit === 'true') return;
        btn.dataset.mmInit = 'true';
        btn.addEventListener('click', function () {
          var item = btn.closest('.mm-acc__item');
          var open = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }
    function run() { document.querySelectorAll('.mm-warr-section').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.mm-warr-section'); if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    var tabs = document.querySelectorAll('.mm-tabs');
    if (!tabs.length) return;
    tabs.forEach(function (tabsEl) {
      if (tabsEl.dataset.mmTabsInit === 'true') return;
      tabsEl.dataset.mmTabsInit = 'true';
      var buttons = tabsEl.querySelectorAll('.mm-tabs__button');
      var panels = tabsEl.querySelectorAll('.mm-tabs__panel');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-mm-tab');
          buttons.forEach(function (b) { b.classList.remove('mm-tabs__button--active'); b.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('mm-tabs__panel--active'); });
          btn.classList.add('mm-tabs__button--active');
          btn.setAttribute('aria-selected', 'true');
          var activePanel = tabsEl.querySelector('[data-mm-panel="' + target + '"]');
          if (activePanel) activePanel.classList.add('mm-tabs__panel--active');
        });
      });
    });
  })();

  // Position the in-stock line under the product title in the buy column.
  (function () {
    function placeChip() {
      var chip = document.querySelector('product-meta-chip.mm-meta');
      if (!chip || chip.dataset.placed === 'true') return;
      var title = document.querySelector('.product-information h1') || document.querySelector('.shopify-section h1');
      if (!title) return;
      title.insertAdjacentElement('afterend', chip);
      chip.removeAttribute('hidden');
      chip.dataset.placed = 'true';
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeChip);
    } else {
      placeChip();
    }
    setTimeout(placeChip, 400);
  })();

  // Relocate the Item Details box into the buy column, after the buy buttons.
  (function () {
    function relocate() {
      var box = document.querySelector('product-item-details.mm-item-details');
      if (!box || box.dataset.moved === 'true') return;
      var buyBtns = document.querySelector('.buy-buttons-block, .product-information product-form, .product-form');
      if (!buyBtns) return;
      var col = buyBtns.closest('.group-block-content') || buyBtns.parentElement;
      if (!col) return;
      col.appendChild(box);
      box.removeAttribute('hidden');
      box.dataset.moved = 'true';
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', relocate);
    } else {
      relocate();
    }
    setTimeout(relocate, 400);
  })();

  // Custom solid-white gallery arrows (Horizon's glass arrows are hidden via CSS)
  (function () {
    function buildArrows() {
      var slideshow = document.querySelector('.product-information slideshow-component');
      if (!slideshow || slideshow.dataset.customArrows === 'true') return;
      var container = slideshow.querySelector('slideshow-container') || slideshow;
      if (!container) return;
      slideshow.dataset.customArrows = 'true';
      if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
      var chevL = '<svg viewBox="0 0 24 24" fill="none" stroke="#16181B" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>';
      var chevR = '<svg viewBox="0 0 24 24" fill="none" stroke="#16181B" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'mm-custom-arrow mm-custom-arrow--prev'; prev.setAttribute('aria-label', 'Previous image'); prev.innerHTML = chevL;
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'mm-custom-arrow mm-custom-arrow--next'; next.setAttribute('aria-label', 'Next image'); next.innerHTML = chevR;
      prev.addEventListener('click', function () { var n = slideshow.querySelector('.slideshow-control--previous'); if (n) n.click(); });
      next.addEventListener('click', function () { var n = slideshow.querySelector('.slideshow-control--next'); if (n) n.click(); });
      container.appendChild(prev);
      container.appendChild(next);
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', buildArrows); } else { buildArrows(); }
    setTimeout(buildArrows, 500);
  })();

  // Image counter badge ("1 / 7") in the gallery corner
  (function () {
    function setupCounter() {
      var slideshow = document.querySelector('.product-information slideshow-component, .product-information [class*="slideshow"]');
      if (!slideshow || slideshow.dataset.counterInit === 'true') return;
      var container = slideshow.querySelector('slideshow-container') || slideshow;
      var dots = slideshow.querySelectorAll('[aria-label^="Slide "]');
      var total = 0;
      if (dots.length) {
        var m = dots[0].getAttribute('aria-label').match(/of (\d+)/);
        total = m ? parseInt(m[1], 10) : dots.length;
      }
      if (!total) return;
      slideshow.dataset.counterInit = 'true';
      if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
      var badge = document.createElement('div');
      badge.className = 'mm-img-counter';
      var current = 1;
      function render() { badge.textContent = current + ' / ' + total; }
      render();
      container.appendChild(badge);
      slideshow.addEventListener('click', function (e) {
        var dot = e.target.closest('[aria-label^="Slide "]');
        if (dot) {
          var dm = dot.getAttribute('aria-label').match(/Slide (\d+)/);
          if (dm) { current = parseInt(dm[1], 10); render(); }
          return;
        }
        if (e.target.closest('.slideshow-control--next')) { current = current % total + 1; render(); }
        if (e.target.closest('.slideshow-control--previous')) { current = (current - 2 + total) % total + 1; render(); }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupCounter);
    } else {
      setupCounter();
    }
    setTimeout(setupCounter, 500);
  })();

  // Item Details collapsible (open by default; toggle on header click)
  (function () {
    document.addEventListener('click', function (e) {
      var head = e.target.closest('.mm-item-details__head');
      if (!head) return;
      var box = head.closest('product-item-details');
      if (!box) return;
      var open = box.getAttribute('data-open') === 'true';
      box.setAttribute('data-open', open ? 'false' : 'true');
      head.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
